export enum SpaceDirection {
  HORIZONTAL = "horizontal",
  VERTICAL = "vertical",
}
